import { isServer } from "@commons-monorepo/index";
import { ProductProps } from "./Product.type";
import { ProductSkin1 } from "./skins";
import { ShareStore } from "../catalogue/components/share-store";
import ContactButtonConfigured from "../addons/components/contact-button-configured/contact-button-configured";

export const ProductComponent = (props: ProductProps) => {
  return (
    <>
      <ContactButtonConfigured productName={props.product.name} />
      <div aria-label='product-detail-view'>
        <ProductSkin1 {...props} />
        {!isServer && <ShareStore product={props.product} />}
      </div>
    </>
  );
};

export default ProductComponent;
